<!-- 该案例暂时不提供 -->
<template>
  <div class="page">
    <div class="content_page">
      <h1 class="detail_page_header">
        象山影视城“唐宋奇妙夜”文化夜游活动火爆开启，云翰虹章技术支持助力创新体验
      </h1>
      <h2>灯光投影秀</h2>
      <img
        src="../../../assets/img/PlanandCases/CultureTour/CityWallProjectionPage/LightShowPageimg1.png"
        alt="meeting"
        class="image"
      />
      <p>
        2023年7月，为期三个多月的“唐宋奇妙夜”文化夜游活动在象山影视城正式开启。该活动一经推出便取得了极高的热度，无数游客慕名而来，前往名景点打卡并分享。
        象山影视城位于浙江省宁波市象山县，曾获2017年度旅游景区人气奖，并被评为国家4A级景区。自2005年开城以来，象山影视城先后拍摄了1500多部影视作品，其中不乏《神雕侠侣》等知名影视剧。本次“唐宋奇妙夜”由象山影视城推出，并由云翰虹章提供相关的技术服务。
        在“唐宋奇妙夜”活动中，每晚19：00-20：00在襄阳城景点准时演出的古城墙灯光投影秀广受追捧，单日人流量最高达到5.5万人。该灯光投影秀分为舞蹈编排与城墙投影两个部分，其中城墙投影部分采用了基于虚幻引擎的超写实CG动画制作，并由云翰虹章提供技术支持。此次灯光投影秀结合了传统的舞蹈表演与投影技术，展示了象山影视城制作的一系列知名影视剧（如：《琅琊榜》《庆余年》）中的经典场面，为观众带来了新奇的视听体验。
        作为此次活动的重要技术支持方，我们非常荣幸能够参与到这一项目中，并展示我们的技术实力与创意。未来，云翰虹章将继续与象山影视城携手，共同探索文化旅游领域的新内容，为观众带来更多精彩的视听体验。
      </p>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>
